// extracted by mini-css-extract-plugin
module.exports = {"root":"PaymentsMobile_root__3VtMh","item":"PaymentsMobile_item__1c7xN","label":"PaymentsMobile_label__nq-l9","amount":"PaymentsMobile_amount__1NOgO"};